module.exports = __webpack_public_path__ + "img/DJI_0523.e6873476.jpg";